import React,{useContext} from "react";

import StudentNav from '../Navbars/StudentNav'
import AdminNav from '../Navbars/AdminNav' 
import GuestNav from "../Navbars/GuestNav";

import { UserContext } from '../UserContext';
import Footer from '../Footer'
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./ArtsPortal.css";
// import "../MathPortal/Slider.css";
// import "../MathPortal/MathCourseDetails.css";
// import "../MathPortal/MathPortalResponsive.css";
import { MDBAccordion, MDBAccordionItem, MDBContainer } from "mdb-react-ui-kit";
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import { MDBRow, MDBCol } from "mdb-react-ui-kit";
import pic1 from "./ArtsCourseImages/icon.png";
// import pic2 from "./GraphicCourseImages/corelDraw.png";
// import pic3 from "./GraphicCourseImages/photoShop.png";
// import pic4 from "./GraphicCourseImages/canva.png";
// import pic5 from "./GraphicCourseImages/illustrator.png";
// import pic6 from "./GraphicCourseImages/figma.png";
// import pic7 from "./GraphicCourseImages/trinkcard.jpg";
// import TeacherNav from "../Navbars/TeacherNav";
import FeeStructure from "../components/FeeStructure";
import GCD from './ArtsCourseImages/Arts.jpg'
import Testimonials from '../Testimonials'


const GraphicCourseDetails = ({selectedCourse}) => {
  
  const handleCourseSelect = (course) => {
    console.log("Selected Course in Home:", course);
    selectedCourse(course);
  };

 const { isAdmin, isTeacher, isStudent, isGuest, setUserRole, setUserInfo,userInfo } = useContext(UserContext);   
 
    useEffect(() => {
      const fetchData = async () => {
       await fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}`, {
          credentials: 'include',
        }).then(response => {
            console.log("Response:",response);
          response.json().then(userInfo => {
            console.log("userinfo:",userInfo);
            setUserInfo(userInfo);

            if(userInfo?.usertype)
            {
              const uType=userInfo?.usertype;
              setUserRole(uType);
            }
          const uname = userInfo?.username;
          const avatar = userInfo?.avatar; // Store the avatar in a separate variable
          console.log("Uname: ", uname);
          console.log("Avatar: ", avatar);

          })
          .catch(err=> console.log("Error in useeffect:",err))
        });
      }
      fetchData();
    }, [isAdmin, isTeacher, isStudent, isGuest]);
  const determineUserRole = (usertype) => {
        console.log("In home.js:",usertype)
        if(usertype === 'Student')
          return "Student";
        else if(usertype === 'Teacher')
          return "Teacher";
        else if(usertype === 'Admin')
          return "Admin";
        else
          return "guest";
  };
 const navigate=useNavigate();
  const onLogin = (usertype) => {
    const userRole = determineUserRole(usertype);
    console.log("Calling setUserRole.")
    setUserRole(userRole);
  };

  function onLogout() {
      console.log("inside Onlogout.");
      fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}/logout`, {
        credentials: 'include',
        method: 'POST',
      });
      setUserInfo(null);
      setUserRole('guest');
      navigate("/");

    }
      
      const username = userInfo?.username;
      const _avatar_ = userInfo?.avatar;
   
  return (
    <div  >
      
     {/* Navbar */}
     {username && (
        <>
        {isAdmin && <AdminNav  username={username} avatar={_avatar_} onLogout={onLogout} />}
        {isTeacher && <TeacherNav  username={username} avatar={_avatar_} onLogout={onLogout}/>}
        {isStudent && <StudentNav  username={username} avatar={_avatar_} onLogout={onLogout} />}
      </>
        )}  
        {!username && (
          <>
          {isGuest && <GuestNav onLogin={onLogin} />}

          </>
        )}
    

    <div className="GraphicPortalBackground">
       <section className="section">
         <p className="PageHead" style={{ color: "#8b0194" }}>Arts Portal</p>
         <div className="PageDesc">
         <div style={{display:"flex"}}>
           <p style={{
                fontFamily: "KG Primary Whimsy,VanillaMilk,'DM Sans', sans-serif",
                color: "white",
                textAlign: "left",
                padding: "30px",
                fontSize: "22px",
                zIndex: 1,
                color: "#8b0194",
                width:"70%"
                
              }}>
           In a world filled with digital communication, the timeless art of calligraphy stands out as a graceful way to express creativity and personality. From elegant invitations and logos to personalized gifts and decorative art, calligraphy adds a unique touch to words, making them visually captivating.



           </p>
           <img style={{minWidth:"250px", maxWidth:"450px", height:"300px"}} src={GCD}></img>
           </div>
           <div className="btn-row d-flex btn-row-resp btn-row-resp1">

             {/* <div className="btn-row-resp"> */}
             <div style={{color:"#e2e872", width: "auto", height: "50px" }}>


               <a className="btn-row-resp button " href="#course">Individual Courses</a>
             </div>
             <div style={{ width: "auto", height: "50px" }}>


               <a className="btn-row-resp button btn-color-fee" href="#fee">Fee Structure</a>
             </div>
             
             <div style={{ width: "auto", height: "50px" }}>

               <a className=" btn-row-resp button btn-color-Testimonal" href="#testimonal">Testimonals</a>
             </div>
             <div style={{ width: "auto", height: "50px" }}>
               <a className=" btn-row-resp button btn-color-Faq" href="#Faq">Faqs</a>


             </div>
             <div style={{ width: "auto", height: "50px" }}>
             <a className=" btn-row-resp button btn-color-registered" href="#">Get Registered</a> 
              

             </div>


        
           </div>
         </div>

       </section>
       <div className="overlay"></div>
     </div>
     
     

{/* Individual courses */}
<div style={{ backgroundColor: '#d8f2fb' }} id="course">
       <p className="PageHead mx-auto" style={{ color: "#8b0194" }}>
       Arts Individual Courses 
       </p>

       <div className="container"  >

         <MDBRow>
           <MDBCol md='4'>
             <div className=" col-xs-6">
               <Link to="/arts_portal_calligraphy">
                 <div className='ind-course-border d-flex' style={{ paddingTop: "1em" }}>

                   <h3 className="ind-course-title "> Calligrapghy</h3>
               <div>
                     <img src={pic1} alt="" style={{width:"100px",height:"80px", alignItems:"center"}}/>
                 </div>
                 
                    </div>
                
               </Link>
             </div>
           </MDBCol>
                    </MDBRow>
       </div>


     </div>


    {/* Fee Structure */}
    <FeeStructure subject="Coding"/>
    

    < Testimonials />

     {/* Faqs */}
     <div style={{ maxWidth: '100%', backgroundColor: '#edffff' }} id="Faq">
  <MDBContainer className="mt-0" style={{ maxWidth: '180vh' }}>
    <MDBAccordion alwaysOpen initialActive={1}>
      <div className="text-center PageHead" style={{ color: "#8b0194" }}> FAQs</div>
      
      <MDBAccordionItem collapseId={1} headerTitle="Q: What types of art courses do you offer?">
        <strong>A: </strong>
        We are currently offering calligraphy courses; more courses will come soon.
      </MDBAccordionItem>
      
      <MDBAccordionItem collapseId={2} headerTitle="Q: Who can enroll in these art courses?">
        <strong>A: </strong>
        Our courses are open to children, teens, and beginners of all ages. Some classes may have age or skill-level recommendations, which will be specified in the course details.
      </MDBAccordionItem>
      
      <MDBAccordionItem collapseId={3} headerTitle="Q: Do students need to have prior experience in art?">
        <strong>A: </strong>
        No! Most of our courses are beginner-friendly, with step-by-step guidance. Advanced courses have some prerequisites.
      </MDBAccordionItem>
      
      <MDBAccordionItem collapseId={4} headerTitle="Q: What materials or tools are required for the classes?">
        <strong>A: </strong>
        Depending on the course, students may need basic supplies like pencils, pens, or digital tools. A detailed list will be shared upon enrollment.
      </MDBAccordionItem>
      
      <MDBAccordionItem collapseId={5} headerTitle="Q: How do these courses help beyond just learning art?">
        <strong>A: </strong>
        Art education enhances creativity, problem-solving, patience, and fine motor skills, while also providing a relaxing and confidence-boosting outlet for self-expression.
      </MDBAccordionItem>
      
    </MDBAccordion>
  </MDBContainer>
</div>
{/* Footer */}
<Footer/>

 </div>
    
  )
}

export default GraphicCourseDetails
